import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { ServiceClient } from "../../parentApi";

export default new ServiceClient(app_uri, axiosClient());
